import React from 'react';
import { Button } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';

const getEmoji = (el) => {
  switch (el.id || el.reportType) {
    case '2001':
    case '2002':
      return (
        <div className="fx actr mr8">
          <SVGIcon name="ChartLine" />
        </div>
      );
    case 'PDF':
      return (
        <div className="fx actr mr8">
          <SVGIcon name="PowerPointIcon" />
        </div>
      );
    case 'METRIC':
      return (
        <div className="fx actr mr8">
          <SVGIcon name="MetricReport" />
        </div>
      );
    case 'DATA':
      return (
        <div className="fx actr mr8">
          <SVGIcon name="DataReport" />
        </div>
      );
    default:
      return (
        <div className="fx actr mr8">
          <SVGIcon name="MetricReport" />
        </div>
      );
  }
};

const NavToggle = (props) => {
  return <Button icon={<SVGIcon name="CustomViewsPanel" size="lg" />} />;
};

export { getEmoji, NavToggle };
